module.exports = __webpack_public_path__ + "img/jHome.b4e51b85.png";